import { useMemo } from "react"
import useCarrotPlan from "./useCarrotPlan"
import useGetMemberBenefit from "./useGetMemberBenefit"
import { useEnabledJourneyOptions, isJourneySupported } from "./useJourneyOptions"
import useGetMemberJourneyData from "#/hooks/useGetMemberJourneyData"

type UseJourneyReturn = {
  journeyDataIsLoaded: boolean
  resolvedJourney: string | null
  memberHasJourneyType: boolean
}

export function useJourney(): UseJourneyReturn {
  const carrotPlanQuery = useCarrotPlan()
  const memberBenefitQuery = useGetMemberBenefit()
  const memberJourneyQuery = useGetMemberJourneyData()
  const { journeyOptions } = useEnabledJourneyOptions(memberBenefitQuery.data)
  const memberHasJourneyType = Boolean(memberJourneyQuery.data?.currentMemberJourney.withInProgressRouting.journey)

  const journeyDataIsLoaded = [memberBenefitQuery, memberJourneyQuery, carrotPlanQuery].every(
    (query) => !query.isLoading
  )

  const resolvedJourney = useMemo(() => {
    if (!journeyDataIsLoaded) return null

    const journeySelection = memberJourneyQuery.data?.currentMemberJourney.preferSubmittedRouting.journey

    if (isJourneySupported({ journey: journeySelection, options: journeyOptions })) {
      return journeySelection
    }

    return null
  }, [
    journeyDataIsLoaded,
    journeyOptions,
    memberJourneyQuery.data?.currentMemberJourney.preferSubmittedRouting.journey
  ])

  return {
    journeyDataIsLoaded,
    memberHasJourneyType,
    resolvedJourney
  }
}
